import React from 'react';
import { OfferCard, OfferLink } from '../components/OfferCard';
import { ProductCard } from '../components/ProductCard';
import { EmailSignup } from '../components/EmailSignup';
import { Button } from '../components/ui/Button';
import { Gift, Globe, MapPin, TrendingUp, DollarSign, Coffee, Battery, Utensils, Laptop, Heart, Youtube, ArrowRight } from 'lucide-react';
export function LandingPage() {
  const scrollToOffers = () => {
    document.getElementById('offers')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-51">
      {/* HERO SECTION */}
      <header className="relative bg-gray-900 text-white overflow-hidden" data-id="element-52">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-600/20 to-purple-900/40 z-0" data-id="element-53"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1513201099705-a9746e1e201f?q=80&w=2897&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-54"></div>

        <div className="container mx-auto px-4 py-24 md:py-32 relative z-10 text-center" data-id="element-55">
          <div className="inline-block animate-bounce mb-6" data-id="element-56">
            <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-57">
              Limited Time Offers
            </span>
          </div>
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-58">
            FREE BIZTOWN <br data-id="element-59" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-500" data-id="element-60">
              GIFTS WORLDWIDE
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-61">
            Get access to exclusive offers, free gifts, and amazing deals from
            around the world.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-62">
            <Button size="lg" onClick={scrollToOffers} className="group" data-id="element-63">
              Explore Free Offers
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-64" />
            </Button>
            <a href="https://www.youtube.com/@KennethDaniel_KenD1" target="_blank" rel="noopener noreferrer" data-id="element-65">
              <Button variant="outline" size="lg" className="border-white/30 text-white hover:bg-white/10 hover:text-white hover:border-white w-full sm:w-auto" data-id="element-66">
                <Youtube className="mr-2 w-5 h-5 text-red-500" data-id="element-67" />
                Watch on YouTube
              </Button>
            </a>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16 space-y-24" data-id="element-68">
        {/* REGIONAL OFFERS */}
        <section id="offers" data-id="element-69">
          <div className="text-center mb-12" data-id="element-70">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-71">
              Exclusive Regional Offers
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-72">
              Select your region to unlock specific rewards and gifts tailored
              just for you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-73">
            <OfferCard title="USA Exclusive Offers" description="Special deals and zip-submit offers available only for residents of the United States." type="regional" badge="USA Only" icon={<MapPin className="w-8 h-8 text-blue-600" data-id="element-75" />} links={[{
            label: 'Claim USA Offer',
            url: 'https://sites.google.com/view/2025december-emailzipsubmitusa/home',
            primary: true
          }]} data-id="element-74" />
            <OfferCard title="Slovenia Special Offers" description="Exclusive gifts and opportunities curated specifically for our Slovenian friends." type="regional" badge="Slovenia Only" icon={<MapPin className="w-8 h-8 text-green-600" data-id="element-77" />} links={[{
            label: 'Claim Slovenia Offer',
            url: 'https://sites.google.com/view/slovenian-offers-081225/home',
            primary: true
          }]} data-id="element-76" />
            <OfferCard title="Worldwide Gifts" description="Global access to free gifts and rewards. Available from any device, anywhere in the world." type="regional" badge="Global" icon={<Globe className="w-8 h-8 text-purple-600" data-id="element-79" />} links={[{
            label: 'Access Worldwide Gifts',
            url: 'https://sites.google.com/view/freebiztowngiftsworldw20251208/home',
            primary: true
          }]} data-id="element-78" />
          </div>
        </section>

        {/* TRADING OFFERS */}
        <section className="bg-gray-900 -mx-4 px-4 py-16 md:rounded-3xl relative overflow-hidden" data-id="element-80">
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-81"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl -ml-20 -mb-20" data-id="element-82"></div>

          <div className="relative z-10" data-id="element-83">
            <div className="text-center mb-12" data-id="element-84">
              <span className="text-blue-400 font-bold tracking-wider uppercase text-sm" data-id="element-85">
                Financial Freedom
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4" data-id="element-86">
                Premium Trading Bonuses
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-87">
                Start your trading journey with exclusive bonuses and
                competitive spreads.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-88">
              <OfferCard title="PrimeXBT: $100 FREE Bonus" description="Start trading with a free $100 gift using our friendly link. Experience the platform with zero risk." type="trading" badge="$100 Bonus" icon={<TrendingUp className="w-8 h-8 text-blue-500" data-id="element-90" />} links={[{
              label: 'Get $100 Gift',
              url: 'https://ref.primexbt.direct/1544419?is_gifted=true',
              primary: true
            }, {
              label: 'Affiliate Rewards',
              url: 'https://go.prmx.co/visit/?bta=39974&brand=primexbt'
            }]} data-id="element-89" />
              <OfferCard title="Exness: Low Spread Trading" description="Join Exness for competitive trading conditions, instant withdrawals, and professional tools." type="trading" badge="Top Rated" icon={<DollarSign className="w-8 h-8 text-green-500" data-id="element-92" />} links={[{
              label: 'Join Exness Now',
              url: 'https://one.exness.link/a/c_hijb6wjx0k',
              primary: true
            }, {
              label: 'View Promo Page',
              url: 'https://www.exnesspromo.com/en/trade-with-low-spread/?partner_id=c_hijb6wjx0k'
            }]} data-id="element-91" />
            </div>
          </div>
        </section>

        {/* AMAZON PRODUCTS */}
        <section data-id="element-93">
          <div className="flex flex-col md:flex-row justify-between items-end mb-10 gap-4" data-id="element-94">
            <div data-id="element-95">
              <h2 className="text-3xl font-bold mb-2" data-id="element-96">Top Amazon Picks</h2>
              <p className="text-gray-600" data-id="element-97">
                Curated products with high ratings and great value.
              </p>
            </div>
            <div className="hidden md:block h-1 flex-1 bg-gray-200 mx-8 rounded-full self-center" data-id="element-98"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-99">
            <ProductCard title="Wild Foods Organic Mushroom Hot Chocolate" description="Non-GMO, Vegan, Gluten Free, Reishi Mushrooms, Chaga. A healthy superfood treat." url="https://bit.ly/43oVLEX" icon={<Coffee className="w-10 h-10" data-id="element-101" />} data-id="element-100" />
            <ProductCard title="Jackery Portable Power Station Explorer 300" description="293Wh Backup Lithium Battery, Solar Generator for Outdoors Camping & Travel." url="https://bit.ly/3JrhSUj" icon={<Battery className="w-10 h-10" data-id="element-103" />} data-id="element-102" />
            <ProductCard title="KitchenAid Grain and Rice Cooker" description="8 Cup with Automatically Sensing Integrated Scale + Water Tank. Matte Black." url="https://bit.ly/4nx9EYO" icon={<Utensils className="w-10 h-10" data-id="element-105" />} data-id="element-104" />
            <ProductCard title="HP 14 Laptop Intel Celeron" description="4GB RAM, 64GB Storage, Windows 11 Home, Thin & Portable. Includes Microsoft 365." url="https://bit.ly/47cG9Xg" icon={<Laptop className="w-10 h-10" data-id="element-107" />} data-id="element-106" />
            <ProductCard title="Natural Dog Company Salmon Oil" description="Omega 3 Fish Oil Supplement for Dogs. Supports Skin, Coat, Joints & Heart Health." url="https://bit.ly/4oD5Shh" icon={<Heart className="w-10 h-10" data-id="element-109" />} data-id="element-108" />
          </div>
        </section>

        {/* LOAN SECTION */}
        <section className="bg-orange-50 border border-orange-100 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-110">
          <div className="flex-1" data-id="element-111">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-112">
              Need Private Loan Funding?
            </h2>
            <p className="text-lg text-gray-600 mb-4" data-id="element-113">
              We provide guaranteed private loan funding at a fixed{' '}
              <span className="font-bold text-orange-600" data-id="element-114">
                2% interest rate
              </span>{' '}
              for all applicants.
            </p>
            <div className="flex items-center text-sm text-gray-500" data-id="element-115">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-116"></div>
              Fast Approval Process
            </div>
          </div>
          <div className="shrink-0" data-id="element-117">
            <a href="mailto:ApexLendsFinancia@hotmail.com" data-id="element-118">
              <Button size="lg" className="shadow-orange-200" data-id="element-119">
                Contact Us for Details
              </Button>
            </a>
          </div>
        </section>

        {/* EMAIL SIGNUP */}
        <section data-id="element-120">
          <EmailSignup data-id="element-121" />
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-122">
        <div className="container mx-auto px-4 text-center" data-id="element-123">
          <div className="flex justify-center mb-8" data-id="element-124">
            <Gift className="w-10 h-10 text-orange-500" data-id="element-125" />
          </div>
          <h3 className="text-white text-xl font-bold mb-4" data-id="element-126">
            FREE BIZTOWN GIFTS WORLDWIDE
          </h3>
          <p className="mb-8 max-w-md mx-auto" data-id="element-127">
            Join thousands of others getting free gifts, exclusive deals, and
            financial opportunities worldwide.
          </p>

          <div className="flex justify-center space-x-6 mb-8" data-id="element-128">
            <a href="https://www.youtube.com/@KennethDaniel_KenD1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-129">
              <div className="flex items-center gap-2" data-id="element-130">
                <Youtube className="w-6 h-6" data-id="element-131" />
                <span className="font-medium" data-id="element-132">Subscribe on YouTube</span>
              </div>
            </a>
          </div>

          <div className="text-sm border-t border-gray-800 pt-8" data-id="element-133">
            <p data-id="element-134">
              &copy; {new Date().getFullYear()} Free Biztown Gifts. All rights
              reserved.
            </p>
            <p className="mt-2 text-xs text-gray-600" data-id="element-135">
              Disclaimer: This page contains affiliate links. We may earn a
              commission if you make a purchase through these links at no extra
              cost to you.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}